var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtvToSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#0A4FB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3512 16.6001H42.8512C43.347 16.6001 43.7629 16.7681 44.0989 17.1041C44.4349 17.4401 44.6023 17.8554 44.6012 18.3501C44.6012 18.8459 44.4332 19.2618 44.0972 19.5978C43.7612 19.9338 43.3458 20.1013 42.8512 20.1001H18.3512C17.8553 20.1001 17.44 19.9321 17.1052 19.5961C16.7703 19.2601 16.6023 18.8448 16.6012 18.3501C16.6012 17.8543 16.7692 17.4389 17.1052 17.1041C17.4412 16.7693 17.8565 16.6013 18.3512 16.6001ZM18.3512 44.6001C17.8553 44.6001 17.44 44.4321 17.1052 44.0961C16.7703 43.7601 16.6023 43.3448 16.6012 42.8501V34.1001H16.2949C15.7408 34.1001 15.2887 33.8883 14.9387 33.4648C14.5887 33.0413 14.472 32.5531 14.5887 32.0001L16.3387 23.2501C16.4262 22.8418 16.6303 22.5063 16.9512 22.2438C17.272 21.9813 17.6366 21.8501 18.0449 21.8501H43.1574C43.5658 21.8501 43.9303 21.9813 44.2512 22.2438C44.572 22.5063 44.7762 22.8418 44.8637 23.2501L46.6137 32.0001C46.7303 32.5543 46.6137 33.0425 46.2637 33.4648C45.9137 33.8872 45.4616 34.0989 44.9074 34.1001H44.6012V42.8501C44.6012 43.3459 44.4332 43.7618 44.0972 44.0978C43.7612 44.4338 43.3458 44.6013 42.8512 44.6001C42.3553 44.6001 41.94 44.4321 41.6052 44.0961C41.2703 43.7601 41.1023 43.3448 41.1012 42.8501V34.1001H34.1012V42.8501C34.1012 43.3459 33.9332 43.7618 33.5972 44.0978C33.2612 44.4338 32.8458 44.6013 32.3512 44.6001H18.3512ZM20.1012 41.1001H30.6012V34.1001H20.1012V41.1001ZM18.4387 30.6001H42.7637L41.7137 25.3501H19.4887L18.4387 30.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtvToSales);
export default __webpack_public_path__ + "static/media/rtv_to_Sales.b8fb72388a4c9227b30c512e65cfae68.svg";
export { ForwardRef as ReactComponent };